<template>
    <div class="stream__row" id="position">
            <div class="stream__row__title">
                <div class="stream__row__titleRobot">
                    <div class="stream__row-avatar f-ava f-ava--min">
                        <img src="../../../../assets/img/robot.jpg" class="f-ava__img"/>
                    </div>
                    <div class="stream__row-robot">
                        Торговый робот
                    </div>
                </div>
                <div class="stream__row__title__item">
                    {{data.timeExit ? $datef(data.timeExit) : $datef(data.timeEnter)}}
                </div>
            </div>
            <div class="stream__row__title stream__row__title-min">
                <div class="stream__row__title__item" style="margin-left:12px;">{{data.timeExit ? 'ОРДЕР ЗАКРЫТ' : 'ОРДЕР ОТКРЫТ'}}</div>
                <div class="stream__row__title__item">№{{data.id}}</div>
                <div class="stream__row__title__item"
                    :class="data.side < 0 ? 'color-red': 'color-green'">{{
                            data.side < 0 ? 'SELL' : 'BUY'
                        }}</div>
                <div class="stream__row__title__item">{{data.symbol}}</div>
            </div>
            <div  v-if="data.timeExit" class="stream__row__data">
                <div class="stream__row__data__itemTitle">{{`Закрытие позиции №${data.id}`}}</div>
                <div class="stream__row__data__itemData">{{`${sellOrBuy(data.side)} ${$moneyf(data.volume)} ${data.symbol}`}}</div>
            </div>
            <div v-if="data.timeExit" class="stream__row__data">
                <div class="stream__row__data__itemTitle">Время открытия</div>
                <div class="stream__row__data__itemData">{{`${this.$datef(data.timeEnter)} по ${data.priceEnter}`}}</div>
            </div>
            <div v-if="data.timeExit" class="stream__row__data">
                <div class="stream__row__data__itemTitle">Время закрытия</div>
                <div class="stream__row__data__itemData">{{`${this.$datef(data.timeExit)} по ${data.curPrice}`}}</div>
            </div>
            <div v-if="data.timeExit" class="stream__row__data">
                <div class="stream__row__data__itemTitle">результат сделки</div>
                <div class="stream__row__data__itemData" :class="data.resultDepo < 0 ? 'color-red' : 'color-green'">{{`$ ${data.resultDepo} (${data.resultPoint} pip)`}}</div>
            </div>
            <div  v-if="!data.timeExit" class="stream__row__data">
                <div class="stream__row__data__itemTitle">{{`Открытие позиции №${data.id}`}}</div>
                <div class="stream__row__data__itemData">{{`${sellOrBuy(data.side)} ${data.volume} ${data.symbol}`}}</div>
            </div>
            <div  v-if="!data.timeExit" class="stream__row__data">
                <div class="stream__row__data__itemTitle">Время открытия</div>
                <div class="stream__row__data__itemData">{{`${this.$datef(data.timeEnter)} по ${data.priceEnter}`}}</div>
            </div>
        </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: {
        data:{default:{}}
    },
    methods: {
        sellOrBuy(side){
           let type = ''
           if(side < 1)
           type = "SELL"
           else
           type = "BUY"
           return type
        }
    },
    computed: {
        getNowDate() {
            let date = new Date()
            return this.$datef(date)
        }
    }
}
</script>
<style lang="less" scoped>
.stream__row {
    color: #adc7e1;
    background: #3d536b;
    box-sizing: border-box;
    //height: 178px;
    margin: 2px 0px 2px 0px;
    padding-bottom: 12px;
    &__titleRobot {
        display: flex;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        color: #ffffff;
        margin-left: 8px;
    }
    &-avatar {
        margin-right: 8px;
    }
    &__data {
        margin-top: 6px;
        font-family: Roboto;
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.54;
        letter-spacing: normal;
        text-align: left;
        margin-left: 12px;
        &__itemTitle {
            font-family: Arimo;
            font-size: 10px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.6;
            letter-spacing: 0.4px;
            color: #aabed2;
            text-transform: uppercase;
        }
        &__itemData {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.23;
            letter-spacing: 0.4px;
            color: #ffffff;
        }
        &__item {
            display: inline-block;
            margin-left: 14px;
        }
    }
    &__title {
        display: flex;
        justify-content: space-between;
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        padding: 14px 0 14px 0;
        color: #ffffff;
        border-bottom: 1px solid #374b62;
        color: #ffffff;
        border-bottom: 1px solid #374b62;
        &-min {
           padding: 8px 0 8px 0;
        }
        &__item {
            margin-right: 14px;
        }
    }
}
</style>

